<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">売上先マスタ一覧</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          v-if="showFlags.btn_salesdestinationCtrl_10001"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="csvImport()"
        >
          <span class="fal fa-upload mr-1"></span>業務システムへ取込
        </button>
        <button
          v-if="showFlags.btn_salesdestinationCtrl_10001"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="csvExport()"
        >
          <span class="fal fa-download mr-1"></span>楽楽明細へ出力
        </button>
        <button
          v-if="showFlags.btn_salesdestinationCtrl_10001"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="dl()"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
        <button
          v-if="showFlags.btn_salesdestinationCtrl_10001"
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
          @click="$router.push('/salesDestinationEdit')"
        >
          <span class="fal fa-check mr-1"></span>追加
        </button>
        <input
          id="file-upload"
          type="file"
          ref="uploadFile"
          @change="postFile()"
          style="display: none"
        />
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>検索条件</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-search">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">キーワード</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="domKeyword"
                    @keydown.enter="getlist(1)"
                  />
                </div>
                <!-- <div class="col-md-1 contTitle">売上先コード</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <div class="input-daterange input-group" id="datepicker-5">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      name="start"
                      v-model="domIdStart"
                    />
                    <div class="input-group-append input-group-prepend">
                      <span class="input-group-text fs-xl" style="height: 30px"
                        >－</span
                      >
                    </div>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      name="end"
                      v-model="domIdEnd"
                    />
                  </div>
                </div>
                <div class="col-md-1 contTitle">売上先名</div>
                <div class="col-md-5 contCnt">
                  <input
                    type="text"
                    name="txtClientNm"
                    class="form-control form-control-sm"
                    maxlength="200"
                    v-model="domClientName"
                  />
                </div> -->
              </div>
              <!-------------------->
              <div class="row">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed btn-search mx-auto"
                  :disabled="btnDisable"
                  @click="getlist(1)"
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>条件結果</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-list">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content">
              <!-- good table start -->
              <!-- <vue-good-table :columns="columns" :rows="rows">
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <a
                      v-bind:href="
                        '/jyutyuinput?record_id=' + props.row.c_project_number
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-xs btn-primary waves-effect waves-themed"
                      >
                        詳細
                      </button>
                    </a>
                  </div>
                  <div
                    v-else-if="
                      props.column.field == 'c_sales_date_cmp_payment_short'
                    "
                    class="gtablecell btnDetCell"
                  >
                    <span class="dateRow_id">
                      <input
                        type="date"
                        name="txtClientNm"
                        class="form-control form-control-sm dateInput"
                        maxlength="200"
                        :value="props.formattedRow[props.column.field]"
                      />
                      <span class="salesId">{{ props.row.c_sales_id }}</span>
                    </span>
                  </div>

                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
              </vue-good-table> -->
              <vue-good-table
                mode="remote"
                v-on:page-change="onPageChange"
                v-on:sort-change="onSortChange"
                :columns="columns"
                :rows="delegate.items"
                :sort-options="{
                  enabled: false,
                }"
                :pagination-options="{
                  enabled: false,
                  // perPageDropdownEnabled: false,
                  // jumpFirstOrLast: false,
                  // nextLabel: '次へ',
                  // prevLabel: '前へ',
                  // mode: 'pages',
                  // ofLabel: '/',
                  // pageLabel: '',
                }"
                :totalRows="delegate.pager.maxcount"
              >
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <button
                      type="button"
                      class="btn btn-xs btn-block btn-primary waves-effect waves-themed"
                      @click="
                        goTo(
                          '/salesDestinationEdit?id=' + props.row.c_client_id,
                          $event
                        )
                      "
                    >
                      詳細
                    </button>
                    <!-- <button
                      type="button"
                      class="btn btn-xs btn-block btn-primary waves-effect waves-themed"
                      @click="moveDet(props.row.c_client_id)"
                    >
                      詳細
                    </button> -->
                  </div>
                  <div v-else class="gtablecell">
                    {{ props.formattedRow[props.column.field] }}
                  </div>
                </template>
              </vue-good-table>
              <!-- good table end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 成功通知モーダル -->
    <Mo_modal_alert ref="Mo_modal_success">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">{{ message4ModalSuccess }}</span>
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer"><br /></div>
      </template>
    </Mo_modal_alert>
    <!-- 成功通知モーダル -->
    <!-- 削除確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_importConf">
      <template v-slot:title>
        楽楽明細からのCSVファイルをインポートします。<br />
        ・メールアドレスとサブメールアドレス１～３は空白かどうかに関わらず上書きします<br />
        ・顧客名、部署、担当者名、郵便番号、住所１、住所２は空白であれば上書きします<br />
        ・会社種類、表記、管轄拠点は更新対象外です<br />
        ・業務システム側に登録のない顧客コードは取込対象外です<br />
        <br />
        よろしいですか？<br />
      </template>
      <template v-slot:body
        ><br />ご注意ください：この操作は元に戻すことができません</template
      >
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="execImport()"
            type="button"
            class="btn btn-danger shadow-0 bootbox-accept"
          >
            はい</button
          ><button
            @click="closeModal4importConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            いいえ
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- 削除確認モーダル -->
    <!-- エラー確認モーダル -->
    <Mo_modal_alert ref="Mo_modal_errorConf">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >{{ message4ModalErrorConf }}
      </template>
      <template v-slot:body><br /></template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal4ErrorConf()"
            type="button"
            class="btn btn-default bootbox-cancel"
          >
            確認
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";
// import { CONST_LIST_DEFO_COUNT } from "@/constants/constant";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
// import { Cl_client } from "@/functions/Cl_client";
// import { Cl_filemaster } from "@/functions/Cl_filemaster";
//   import { DtoClientsGetReqImple } from "mediadept-common/src/common/dto/DtoClientsGetReqImple";
import { DtoClientsGetResImple } from "furukawa-common/src/common/dto/DtoClientsGetResImple";
import { DtoClientsGetReqImple } from "furukawa-common/src/common/dto/DtoClientsGetReqImple";
//   import { DtoFileMastersGetReqImple } from "mediadept-common/src/common/dto/DtoFileMastersGetReqImple";
//   import { DtoFileMastersGetResImple } from "mediadept-common/src/common/dto/DtoFileMastersGetResImple";
import Encoding from "encoding-japanese";

import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import { Cl_client } from "@/functions/Cl_client";
import CallAPI from "@/functions/Cl_api";
import { Cl_Authorization_menu } from "@/constants/Cl_Authorization_menu";
import { CONST_OP_ALERT_CONTRACT } from "furukawa-common/src/common/constant/Constants";
import { DtoClientsDeleteReq } from "furukawa-common/src/common/dto/abst/DtoClientsDeleteReq";
import { EntityClient } from "furukawa-common/src/common/entity/EntityClient";
import {
  CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR,
  CONST_RAKURAKU_CUSTOMERCODE_NUMLENGTH,
  CONST_RAKURAKU_EXPORT_HEADER,
  CONST_RAKURAKU_CSV_ITEMCOUNT,
} from "furukawa-common/src/common/constant/Constants";
import { DtoFileMastersGetReqImple } from "furukawa-common/src/common/dto/DtoFileMastersGetReqImple";
import { Cl_filemaster } from "@/functions/Cl_filemaster";

@Options({
  components: {
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class SalesDestinationList extends Vue {
  /**
   * パフォーマンス問題の解決案としてテスト的に実装中
   * 残課題：グローバルなメソッドとして宣言して、どこからでも呼び出せるようにしたい
   * 　　　　色々なパターンでも問題ないかの検証
   * @param url
   * @param event
   */
  goTo(url: string, event?: MouseEvent) {
    if (event && (event.ctrlKey || event.metaKey)) {
      window.open(url);
    } else {
      this.$router.push(url);
    }
  }
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  //   delegate = new DtoClientsGetResImple();
  delegate = new DtoClientsGetResImple();
  showFlags = new Cl_Authorization_menu();
  //ボタン制御用
  btnDisable = false;
  //検索条件dom
  domIdStart = "";
  domIdEnd = "";
  domClientName = "";
  domKeyword = "";

  columns = [
    {
      label: "詳細",
      field: "btnDet",
      thClass: "text-center",
      tdClass: "text-center",
      width: "10%",
    },
    {
      label: "売上先コード",
      field: "c_client_id",
      thClass: "text-center",
    },
    {
      label: "売上先名",
      field: "c_client_name",
      thClass: "text-center",
    },
    {
      label: "顧客担当者名",
      field: "c_client_staff_name",
    },
    {
      label: "顧客部署",
      field: "c_client_depart",
    },
    {
      label: "メールアドレス",
      field: "c_client_main_mail",
    },
  ];

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalErrorConf = "";
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getlist(1);
    //設定された権限からメニューの表示非表示を制御
    this.showFlags.getAuthorization(this.$store);
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementById("panel-search");
    const panel2 = document.getElementById("panel-list");
    panel?.classList.add("enable-loader");
    panel2?.classList.add("enable-loader");

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoClientsGetReqImple();

      //検索条件設定
      // dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.count = 9999;
      dto.pager.cursor = currentPage;
      // if (this.domIdStart != "" && this.domIdStart != null)
      //   dto.clientId_start = Number(this.domIdStart);
      // if (this.domIdEnd != "" && this.domIdEnd != null)
      //   dto.clientId_end = Number(this.domIdEnd);

      // dto.clientName = this.domClientName;

      dto.keyword = this.domKeyword;

      //API実行
      //-------
      this.delegate = await Cl_client.getList(dto);
      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoClientsGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      panel?.classList.remove("enable-loader");
      panel2?.classList.remove("enable-loader");
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push("/salesDestinationEdit?id=" + id);
  }

  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }

  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "UriagesakiList";
      dto.keyword = this.domKeyword;

      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);
      Cl_common.logger(res);
      Cl_common.logger(res.url);

      //レスポンス処理
      //-------
      location.href = res.url;
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * 楽楽明細にインポートするCSVファイルをダウンロード
   */
  async csvExport() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //API実行
      //-------
      const res = await Cl_client.exportClients();
      Cl_common.logger(res);
      Cl_common.logger(res.url);

      //レスポンス処理
      //-------
      location.href = res.url;
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * インポート処理の実行
   */
  async execImport() {
    let entityList: EntityClient[] | null;
    // 確認メッセージを閉じる
    const modal: any = this.$refs.Mo_modal_importConf;
    modal.closeModal();
    try {
      // インポート情報を作成
      entityList = await this.createClientEntitys();
      if (entityList == null) {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();

        Cl_common.logger("インポート情報の作成でエラーが発生しました");
        return;
      }
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
      return;
    }

    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      // インポート処理の実行
      await Cl_client.importClients(entityList);
      // 連携成功後
      this.message4ModalSuccess = "業務システムへの取込が完了しました";
      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 業務システムへ取込(CSVインポート)
   */
  async csvImport() {
    // ファイル選択POPUP表示
    const element: any = this.$refs.uploadFile;
    // ファイルの指定を初期化
    element.value = "";
    element.click();
  }
  /**
   * CSV取込
   */
  async confirmImport() {
    // 楽楽明細からダウンロードしたCSVかどうかを確認
    let result = await this.isRakurakuCsvFile();
    if (result) {
      // 形式がOKであれば確認モーダル表示
      const modal: any = this.$refs.Mo_modal_importConf;
      modal.showModal();
      return;
    }
  }
  /**
   * 選択されたファイルが楽楽明細からダウンロードしたCSVファイル形式かどうかを確認する
   */
  async isRakurakuCsvFile() {
    try {
      // インポートファイル
      const element: any = this.$refs.uploadFile;
      const file = element.files[0];
      // ファイルの中身を取得
      const arrayBuffer = await file.arrayBuffer();
      // arrayBufferのバイナリデータを1バイト（8ビット）ごとにアクセスできるUint8Array（符号なし8ビット整数の配列）として扱えるようにする
      const uint8Array = new Uint8Array(arrayBuffer);
      // SJISからUniCodeに変換
      const unicodeString = Encoding.convert(uint8Array, {
        from: "SJIS",
        to: "UNICODE",
        type: "string",
      });
      // 改行区切りで取得
      const lines = unicodeString.split(/\r\n|\n|\r/);
      let rowNumber = 0;
      let entityList: any[] = [];
      let result = true;
      // 1行ずつ処理
      lines.forEach((line) => {
        if (rowNumber == 0) {
          // 先頭の行がヘッダ行かどうかを確認
          if (!this.isHeaderRow(line)) {
            this.message4ModalErrorConf =
              "楽楽明細から出力したCSVファイルを指定してください";
            //モーダル表示
            const modal: any = this.$refs.Mo_modal_errorConf;
            modal.showModal();
            result = false;
          }
        } else {
          // 最終行(空白)は読み込み終了
          if (this.isFinalRow(line)) {
            return;
          }
          // 明細行かどうかを確認
          if (!this.isDetailRow(line)) {
            this.message4ModalErrorConf =
              "楽楽明細から出力したCSVファイルを指定してください";
            //モーダル表示
            const modal: any = this.$refs.Mo_modal_errorConf;
            modal.showModal();
            result = false;
          } else {
            let entity = this.createEntity(line);
            if (entity != null) {
              entityList.push(entity);
            }
          }
        }
        rowNumber++;
      });
      return result;
    } catch (error) {
      console.log("楽楽明細ファイルのチェック処理でエラーが発生しました");
      return false;
    }
  }
  /**
   * 業務システムに取り込む売上先マスタのEntityリストを作成
   */
  async createClientEntitys() {
    try {
      // インポートファイル
      const element: any = this.$refs.uploadFile;
      const file = element.files[0];
      // ファイルの中身を取得
      const arrayBuffer = await file.arrayBuffer();
      // arrayBufferのバイナリデータを1バイト（8ビット）ごとにアクセスできるUint8Array（符号なし8ビット整数の配列）として扱えるようにする
      const uint8Array = new Uint8Array(arrayBuffer);
      // SJISからUniCodeに変換
      const unicodeString = Encoding.convert(uint8Array, {
        from: "SJIS",
        to: "UNICODE",
        type: "string",
      });
      // 改行区切りで取得
      const lines = unicodeString.split(/\r\n|\n|\r/);
      let rowNumber = 0;
      let entityList: any[] = [];
      let result = false;
      // 1行ずつ処理
      lines.forEach((line) => {
        if (rowNumber == 0) {
          // 先頭の行がヘッダ行かどうかを確認
          if (!this.isHeaderRow(line)) {
            return;
          }
        } else {
          // 最終行(空白)は読み込み終了
          if (this.isFinalRow(line)) {
            result = true;
            return;
          }
          // 明細行かどうかを確認
          if (!this.isDetailRow(line)) {
            return;
          } else {
            let entity = this.createEntity(line);
            if (entity != null) {
              entityList.push(entity);
            }
          }
        }
        rowNumber++;
      });
      if (result) {
        return entityList;
      } else {
        return null;
      }
    } catch (error) {
      console.log("売上先マスタのEntityリスト作成でエラーが発生しました");
      return null;
    }
  }
  /**
   * 指定の文字列が楽楽明細からエクスポートしたCSVのヘッダかどうかを確認
   * @param line
   */
  isHeaderRow(line: string) {
    return line == CONST_RAKURAKU_EXPORT_HEADER;
  }
  /**
   * 指定の文字列が楽楽明細からエクスポートしたCSVの明細かどうかを確認
   * @param line
   */
  isDetailRow(line: string) {
    // カンマ区切りにした時の項目の数
    const rakurakuDetailItemCount = CONST_RAKURAKU_CSV_ITEMCOUNT;
    return line.split(",").length == rakurakuDetailItemCount;
  }
  /**
   * 楽楽明細の顧客コード「FK000000」形式かどうかを確認
   * @param str
   */
  isRakurakuCustomerCode(str: string) {
    // return /^FK\d{6}$/.test(str);
    const regex = new RegExp(
      `^${CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR}\\d{${CONST_RAKURAKU_CUSTOMERCODE_NUMLENGTH}}$`
    );
    return regex.test(str);
  }
  /**
   * CSVの明細文字列からEntityを作成する
   * @param line
   */
  createEntity(line: string) {
    let items = line.split(",");
    let entity = new EntityClient();
    // 顧客コード
    let rakurakuCustomerCode = items[0];
    if (!this.isRakurakuCustomerCode(rakurakuCustomerCode)) {
      // 「FK000000」形式でなければNULLを返却（インポート対象外）
      return null;
    }
    // 顧客コード
    entity.c_client_id = Number(
      rakurakuCustomerCode.substring(
        CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR.length
      )
    );
    // 顧客名
    entity.c_client_name = items[1];
    // 部署名
    entity.c_client_depart = items[2];
    // 担当者名
    entity.c_client_staff_name = items[3];
    // 郵便番号
    entity.c_client_zip = items[5];
    // 住所１
    entity.c_client_address_1 = items[6];
    // 住所２
    entity.c_client_address_2 = items[7];
    // メールアドレス
    entity.c_client_main_mail = items[8];
    // サブメールアドレス
    entity.c_client_sub_mail1 = items[9];
    entity.c_client_sub_mail2 = items[10];
    entity.c_client_sub_mail3 = items[11];

    return entity;
  }
  /**
   * 指定の行が最終行(空白)かどうかを確認
   * @param line
   */
  isFinalRow(line: string) {
    return line.length == 0;
  }
  /**
   * ファイルアップロード処理
   */
  async postFile() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      const element: any = this.$refs.uploadFile;
      const uploadFile = element.files[0];

      if (element.files[0].size > 10000000) {
        this.message4ModalErrorConf =
          "アップロードできるファイルサイズは、10Mまでです";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      }

      if (uploadFile != undefined) {
        //マップ画像保存。
        //------------------
        //要素からファイル情報取得。
        const exix = uploadFile.name.split(".").pop();
        if (exix != "CSV" && exix != "csv") {
          this.message4ModalErrorConf = "アップロードできるのは、CSVのみです";
          //モーダル表示
          const modal: any = this.$refs.Mo_modal_errorConf;
          modal.showModal();
          return;
        }
      }
      // ファイルがCSVであれば取込処理開始
      this.confirmImport();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
  async closeModal4importConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_importConf;
    modal.closeModal();
  }
}
</script>
